import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import AuthFunctions from './services/AuthService';

export class Home extends Component {
  static displayName = Home.name;

    constructor(props) {
        super(props);
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    async componentDidMount() {
        document.getElementsByTagName('html')[0].className = "background-main";
    }

  render () {
    return (
        <div className='main'>
            <Container>
                <Row style={{textAlign: 'center', paddingTop: '100px', paddingBottom: '50px'}}>
                    <Col>
                        <h2>Welcome to <span style={{ color: '#233c7c' }}>TICMS</span></h2>
                    </Col>
                </Row>
                <Row style={{ textAlign: 'center', fontSize: '20px', paddingBottom: '50px' }}>
                    <Col style={{ textAlign: 'center' }}>
                        <span style={{ color: '#233c7c', fontWeight: 'bold' }}>OLM</span> program is an exclusive customer <span style={{ color: '#233c7c', fontWeight: 'bold' }}>O</span>n <span style={{ color: '#233c7c' }}>L</span>ine <span style={{ color: '#233c7c', fontWeight: 'bold' }}>M</span>etrology portal.<br/>
                        <span style={{ color: '#233c7c', fontWeight: 'bold' }}>OLM</span> allows <span style={{ color: '#233c7c', fontWeight: 'bold' }}>TICMS</span> clients to upload and manage their assets, calibrations, on-site work and so much more.
                    </Col>
                </Row>
                <Row style={{ textAlign: 'center', fontSize: '20px', paddingBottom: '100px' }}>
                    <Col style={{ textAlign: 'center' }}>
                        Please use the menu icons on the left hand side to navigate through the program.  If you have any questions, please call 314-432-3633 and one of the <span style={{ color: '#233c7c', fontWeight: 'bold' }}>TICMS</span> team members can assist you.
                    </Col>
                </Row>
            </Container>
      </div>
    );
  }
}
